import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import styles from './LikeModal.module.scss';
import ModalCloseButton from '../Modal/ModalCloseButton';
import Button from '../Button/Button';

const LikeModal = ({ isOpen, onClose, onConfirm }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
  >
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <h4 className={styles.title}>
          Изменить выбор?
        </h4>
        <ModalCloseButton className={styles.close} onClick={onClose} />
      </div>
      <div className={styles.desc}>
        <p>Вы уже поддержали другую идею. Можно выбрать только одну идею в обсуждении.</p>
      </div>
      <div className={styles.buttons}>
        <Button
          className={styles.voteBtn}
          typeButton="button-fill"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          Да
        </Button>
        <button type="button" onClick={onClose} className={styles.decideLaterBtn}>Ещё подумаю</button>
      </div>
    </div>
  </Modal>
);

LikeModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

LikeModal.defaultProps = {
  isOpen: false,
};

export default LikeModal;
